import asyncSelect from './asyncSelect.vue';
import dateTime from './dateTime.vue';
import image from './image.vue';
import imageCode from './imageCode.vue';
import number from './number.vue';
import tree from './tree.vue';
export const valueTypeMap = {
    dateTime,
    image,
    imageCode,
    number,
    asyncSelect,
    tree,
};
